import { render } from "./OurDirections.vue?vue&type=template&id=450d8412"
import script from "./OurDirections.vue?vue&type=script&lang=js"
export * from "./OurDirections.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__